var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{ref:"canvas",attrs:{"width":_vm.contentWidth,"height":_vm.contentHeight},on:{"click":function($event){return _vm.refresh()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }